// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "3aeadfa897be38e0baf5ac283b85b085807a3e65/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};